import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBat = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#bat_svg__a)'>
      <path fill='#FF4724' d='M24 12q0 12-12 12T0 12 12 0t12 12' />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M12.217 4.375a.25.25 0 0 0-.434 0l-6.495 11.25a.25.25 0 0 0 .217.375h12.99a.25.25 0 0 0 .217-.375zM12 9l-2.598 4.5h5.196z'
        clipRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='bat_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgBat)
export default ForwardRef
